import { isAuditorTeamTypes, shouldHideAuditorAttribution } from "utils";
import type { VitalsColumnTakenBy } from "../types/types";

export function getVisibleTakenBy(
  takenBy?: VitalsColumnTakenBy | null
): VitalsColumnTakenBy | null {
  if (!takenBy) return null;
  if (shouldHideAuditorAttribution(isAuditorTeamTypes(takenBy.teamTypes)))
    return null;
  return takenBy;
}
